import { Box, useMediaQuery } from "@material-ui/core";
import React from "react";

import { StyledGrid } from "components/simple";
import {
  breakpoints,
  fontFamily,
  fontSize,
  spacingDefaults
} from "style/constants";

interface BGCInfoPageProps {
  icon: string;
  iconAlt: string;
  iconWidth?: number;
  iconHeight?: number;
  heading: string;
  children: React.ReactNode;
}

const BGCInfoPage: React.FC<BGCInfoPageProps> = ({
  icon,
  iconAlt,
  iconWidth = 135,
  iconHeight = 135,
  heading,
  children
}) => {
  const mobile = useMediaQuery(`(max-width:${breakpoints.lg}px)`);

  return (
    <StyledGrid
      alignItems="center"
      container
      direction="column"
      padding={spacingDefaults.xlarge}
    >
      <img alt={iconAlt} height={iconHeight} src={icon} width={iconWidth} />

      <Box
        fontFamily={fontFamily.secondary}
        fontSize={mobile ? fontSize.large : fontSize.xlarge}
        letterSpacing="-0.45px"
        margin={`${spacingDefaults.large} 0`}
        textAlign="center"
      >
        {heading}
      </Box>

      <Box
        fontSize={mobile ? fontSize.small : fontSize.normal}
        lineHeight="180%"
        maxWidth="620px"
        textAlign="center"
      >
        {children}
      </Box>
    </StyledGrid>
  );
};

export default BGCInfoPage;
